import React from "react";
import ArajanlatozoModel from "../components/arajanlatozo/arajanlatozo";

const Arajanlatozo = () => {
  return <ArajanlatozoModel />;
};

export default Arajanlatozo;
